import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { McqService } from '../../service/mcq.service';
import { commonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-quickreport',
  templateUrl: './quickreport.component.html',
  styleUrls: ['./quickreport.component.css'],
  providers: [McqService]
})
export class QuickreportComponent implements OnInit {
  reportId: any;
  userData: any;
  msg = '';
  isError = false;
  reportData: any;
  studendRank: any;
  totalStudentCount: any;
  displayReport:boolean=false;

  constructor(private route: ActivatedRoute, private router: Router, private mcqservice: McqService, private commonService: commonService) {

    this.userData = this.commonService.user;

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.reportId = parseInt(atob(params['id']));
        if (isNaN(this.reportId)) {
          this.reportId = 0;
          this.router.navigateByUrl('/');
        }

        if (this.reportId > 0) {
          this.getStudentReportIdWise();
        }
      }
    });

  }

  ngOnInit() {

  }

  // DISABLE ALL KEYBOAR KEYS
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.returnValue = false;
    event.preventDefault();
  }

  getStudentReportIdWise() {
    let obj = {};
    obj['studentId'] = this.userData.id;
    obj['paperId'] = this.reportId;
    
    this.mcqservice.getStudentReportIdWise(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.reportData.length > 0) {
          this.reportData = data.results.reportData[0];
          this.studendRank = data.results.studendRank[0];
          this.totalStudentCount = data.results.totalStudentCount[0];

          this.isReportVisible(this.reportData);

        } else {
          this.reportData = {};
          this.studendRank = {};
          this.totalStudentCount = {};
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.msg = "internal server error!";
    });
  }

  isReportVisible(solution){
    var date = new Date();
    if(solution.solutionType=='1'){
      this.displayReport = true;
    }else if (solution.solutionType=='2'){
      var sdate = new Date(solution.solutionDisplayDate);
      if(date>=sdate){
        this.displayReport = true;
      }
    }
  }

  getTotalSependedTime(second, totalTime) {
    totalTime  = Number(totalTime)*60;
    if(second>totalTime) second = totalTime;

    return Number(second / 60).toFixed(2);
  }

  roundoff(n) {
    return Number(n).toFixed(2);
  }

  converttoIntfun(val) {
    return parseInt(val);
  }

  setCloseWindowValue(id) {
    if (window.opener != null && !window.opener.closed) {
      var txtName: any = window.opener.document.getElementById("parentWindowType");
      txtName.value = id;

      var paperid: any = window.opener.document.getElementById("parentWindowId");
      paperid.value = btoa(this.reportId);
    }
    window.close();
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/quickreport/quickreport.component.ts